import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_igbodu-agri/artifacts/swcybtk6_WhatsApp%20Image%202026-03-03%20at%2012.01.34%20PM.jpeg";

const navLinks = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Services", path: "/services" },
  { name: "Products", path: "/products" },
  { name: "Gallery", path: "/gallery" },
  { name: "Blog", path: "/blog" },
  { name: "Contact", path: "/contact" },
];

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-stone-200 shadow-sm" data-testid="navbar">
      <div className="container-custom">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
            <img 
              src={LOGO_URL} 
              alt="AfriGrow Farm Logo" 
              className="h-14 w-14 rounded-full object-cover"
            />
            <span className="font-heading text-xl font-bold text-green-600 hidden sm:block">
              AfriGrow Farm
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-${link.name.toLowerCase()}`}
                className={`text-sm font-medium transition-colors hover:text-green-600 ${
                  isActive(link.path) 
                    ? "text-green-600" 
                    : "text-stone-700"
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* CTA Button & Phone */}
          <div className="hidden lg:flex items-center gap-4">
            <a 
              href="tel:+2348026994903" 
              className="flex items-center gap-2 text-stone-600 hover:text-green-600 transition-colors"
              data-testid="phone-link"
            >
              <Phone className="h-4 w-4" />
              <span className="text-sm font-medium">+234 802 699 4903</span>
            </a>
            <Button 
              asChild
              className="bg-green-600 hover:bg-green-700 text-white rounded-full px-6"
              data-testid="get-quote-btn"
            >
              <Link to="/contact">Get a Quote</Link>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-stone-700"
            onClick={() => setIsOpen(!isOpen)}
            data-testid="mobile-menu-btn"
          >
            {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="lg:hidden bg-white border-t border-stone-200" data-testid="mobile-menu">
          <div className="container-custom py-6 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                data-testid={`mobile-nav-${link.name.toLowerCase()}`}
                className={`block py-2 text-base font-medium transition-colors ${
                  isActive(link.path)
                    ? "text-green-600"
                    : "text-stone-700 hover:text-green-600"
                }`}
              >
                {link.name}
              </Link>
            ))}
            <div className="pt-4 border-t border-stone-200">
              <a 
                href="tel:+2348026994903" 
                className="flex items-center gap-2 text-stone-600 py-2"
              >
                <Phone className="h-4 w-4" />
                <span className="font-medium">+234 802 699 4903</span>
              </a>
              <Button 
                asChild
                className="w-full mt-4 bg-green-600 hover:bg-green-700 text-white rounded-full"
              >
                <Link to="/contact" onClick={() => setIsOpen(false)}>Get a Quote</Link>
              </Button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
